/* SOLVEY · Pre-order auto-labeling
   -----------------------------------------------------------------------------
   Actief zodra <html class="solvey-preorder"> is gezet door
   snippets/solvey-preorder.liquid (Restore Probiotics uitverkocht-maar-koopbaar).

   Doet twee dingen op de getroffen PDP's (Restore + de 6 Restore-bundels):
     1) herlabelt de koopknop + sticky-CTA naar "Pre-order"
     2) plaatst een badge "Pre-order · Levering ± 1 week" in de product-header

   Weglot-safe: de knop-tekst komt uit locale-string products.product.preorder
   (server-rendered in #solvey-preorder-data), éénmalig per knop toegepast
   (data-solvey-preorder marker) zodat dit niet met Weglot's DOM-observer vecht.
   De header-badge heeft eigen i18n (wg-notranslate) + update op languageChanged. */
(function () {
  if (!document.documentElement.classList.contains('solvey-preorder')) return;

  function currentLang() {
    if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
      var l = window.Weglot.getCurrentLang();
      if (l) return String(l).toLowerCase().split('-')[0];
    }
    if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().split('-')[0];
    if (document.documentElement.lang) return String(document.documentElement.lang).toLowerCase().split('-')[0];
    return 'nl';
  }

  /* ---------------- knop-label ---------------- */
  function getLabel() {
    var el = document.getElementById('solvey-preorder-data');
    return (el && el.getAttribute('data-label')) || 'Pre-order';
  }

  function relabelButtons(label) {
    var btns = document.querySelectorAll('[data-add-to-cart]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      // Echt-uitverkocht (niet koopbaar) knoppen niet aanraken.
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') continue;
      // Al toegepast op dit knop-element? Laat Weglot's vertaling met rust.
      if (btn.getAttribute('data-solvey-preorder') === label) continue;

      // Update de reset-bron zodat de thema-JS ná add-to-cart óók "Pre-order" toont.
      btn.setAttribute('data-lang-available', label);
      btn.setAttribute('aria-label', label);
      var span = btn.querySelector('[data-add-to-cart-text]');
      if (span) span.textContent = label;
      btn.setAttribute('data-solvey-preorder', label);
    }
  }

  /* ---------------- header-badge (met levertijd) ---------------- */
  // Eigen i18n + wg-notranslate zodat het per taal klopt zonder afhankelijk te
  // zijn van locale-files/Weglot-vertaling.
  var BADGE = {
    pre: { en: 'Pre-order', nl: 'Pre-order', de: 'Vorbestellung', da: 'Forudbestil', fr: 'Précommande' },
    delivery: {
      en: 'Delivery ± 1 week',
      nl: 'Levering ± 1 week',
      de: 'Lieferung ± 1 Woche',
      da: 'Levering ± 1 uge',
      fr: 'Livraison ± 1 semaine'
    }
  };

  function badgeText() {
    var l = currentLang();
    return (BADGE.pre[l] || BADGE.pre.en) + ' · ' + (BADGE.delivery[l] || BADGE.delivery.en);
  }

  function ensureBadge() {
    var host = document.querySelector('.product__block--product-header-inner');
    if (!host) return;
    var badge = host.querySelector('.solvey-preorder-badge');
    if (badge) {
      if (badge.textContent !== badgeText()) badge.textContent = badgeText();
      return;
    }
    badge = document.createElement('span');
    badge.className = 'solvey-preorder-badge wg-notranslate';
    badge.setAttribute('data-wg-notranslate', '');
    badge.textContent = badgeText();
    var title = host.querySelector('.product__title');
    host.insertBefore(badge, title || host.firstChild);
  }

  function apply() {
    relabelButtons(getLabel());
    ensureBadge();
  }

  function boot() {
    apply();
    // Weglot / late DOM / variant-swap: opnieuw toepassen bij mutaties.
    // rAF-debounce + idempotente guards voorkomen een observer-loop.
    var queued = false;
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; apply(); });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      try { window.Weglot.on('languageChanged', ensureBadge); } catch (e) {}
    }
    window.addEventListener('pageshow', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
